<template>
    <b-modal size="md" button-size="sm" hide-footer v-model="modalAberto" :title="title" @abort="cancelar"
        @hidden="cancelar">
        <b-form @submit.prevent="save">
            <b-card>
                <b-container fluid>
                    <b-row class="justify-content-center">
                        <b-col cols="12" sm="12">
                            <lg-form-input invalidFeedback="Informe um login válido!" description=" "
                                :error="$v.form.login" v-model="form.login" label="Login:*" />
                        </b-col>
                    </b-row>


                    <b-row class="justify-content-center">
                        <b-col cols="12" sm="12">
                            <lg-form-input invalidFeedback="Informe um nome válido!" description=" "
                                :error="$v.form.nome" v-model="form.nome" label="Nome:*" />
                        </b-col>
                    </b-row>

                    <lg-finder-page-departamento-sgu class="ml-2 mr-2" :prefix="prefix + titlePage + ' > '"
                        id="finderUnidadeAdministrativaUsuarioForm" @onselect="handleSelectUnidadeAdministrativa"
                        v-model="form.departamentoFinder" invalidFeedback="Informe uma unidade administrativa!"
                        label="Unidade Administrativa:*">
                    </lg-finder-page-departamento-sgu>

                    <b-row class="justify-content-center">
                        <b-col cols="12" sm="12">
                            <lg-form-input invalidFeedback="Informe um matricula válido!" description=" "
                                :error="$v.form.matricula" v-model="form.matricula" label="Matrícula:" />
                        </b-col>
                    </b-row>

                    <b-row class="justify-content-center">
                        <b-col cols="12" sm="12">
                            <lg-form-input type="password" invalidFeedback="Informe uma senha válida!" description=" "
                                :error="$v.form.password" v-model="form.password" label="Senha:*" />
                        </b-col>
                    </b-row>


                    <b-row class="justify-content-center">
                        <b-col cols="12" sm="12">
                            <lg-form-input type="password" invalidFeedback="Informe uma senha válida!" description=" "
                                :error="$v.form.passwordAgain" v-model="form.passwordAgain" label="Repita a Senha:*" />
                        </b-col>
                    </b-row>

                    <b-row class="justify-content-center text-center">
                        <b-col cols="12">

                            <b-button id="salvar" class=" my-2" size="sm" pill variant="success" type="submit">
                                <b-icon icon="check-circle" />
                                <b-tooltip target="salvar" title="Salvar"></b-tooltip>

                            </b-button>

                            <b-button id="cancelar" class=" my-2 ml-2" size="sm" pill variant="danger"
                                @click="cancelar">
                                <b-icon icon="x-circle" />
                                <b-tooltip target="cancelar" title="Cancelar"></b-tooltip>

                            </b-button>

                        </b-col>
                    </b-row>
                </b-container>
            </b-card>
        </b-form>
    </b-modal>
</template>

<script>
import ResourceService from "@/core/api/ResourceService"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import { FormResourceMixin } from "@/core/mixins/resource"
import { required } from "vuelidate/lib/validators"
import LgFinderPageDepartamentoSgu from "@/components/Finders/LgFinderPageDepartamentoSgu.vue";

export default {
    components: {
        LgFormInput,
        LgFinderPageDepartamentoSgu
    },
    mixins: [FormResourceMixin],
    props: {
        pessoa: {
            type: Number,
            default: null
        },

        prefix: Array,
        showModal: {
            type: Boolean,
            default: true,
        },
    },
    validations: {
        form: {
            nome: { required },
            login: { required },
            departamento: { required },
            password: { required },
            passwordAgain: { required },

        },
    },
    data() {
        return {
            modalAberto: true,
            titlePage: "Cadastro",
            form: {
                departamentoFinder: {},
                departamento: {},
                pessoa: this.pessoa,
                nome: "",
                login: "",
                matricula: "",
                password: "",
                passwordAgain: "",
            },
        }
    },
    computed: {
        updatedPrefix() {
            return [...this.prefix, "Cadastro"]
        },
        title() {
            return this.updatedPrefix.join(" > ")
        },
    },
    async beforeMount() {
        this.$service = new ResourceService(`/api/sgu/usuarios`);
        this.titlePage = this.title

    },

    methods: {
        handleSelectUnidadeAdministrativa(departamento) {
            this.form.departamento = departamento.id;
        },
        async save() {
            if (!this.formIsValid) {
                this.$v.$touch()
                this.$notify({
                    type: "danger",
                    message: "Verifique os campos do cadastro.",
                });
                return
            }

            if (this.form.password != this.form.passwordAgain) {
                this.$notify({
                    type: "danger",
                    message: "As senhas precisam ser iguais",
                });

                return;
            }

            try {
                await this.$saveResource(this.form, "", false, {}, false, true);
                this.$emit("close")

            }
            catch (error) {
                this.$notify({
                    type: "danger",
                    message: error.response.data,
                });

            }
        },

        cancelar() {
            this.modalAberto = false
            this.$emit("close")
        },

        resetForm() {
            this.form = {
                departamento: {},
                departamentoFinder: {},
                nome: "",
                cpf: "",
                rg: "",
                email: "",
                orgaoRg: "",
                ufRg: "",
                passaporte: "",
            }
        },
    },
}
</script>
